import md5 from 'js-md5';
const key = 'asxcwN_sdsd23O';

function paramsStrSort(arr) {
    var urlStr = arr.sort().join("&");
    var newUrl = urlStr.trim() + key;
    //最后拼接一个key,根据实际规则看是否需要这个参数
    // var newUrl = urlStr + '&key=' + key;
    //最后一个是转成大写,根据实际规则确定是否需要转
    return md5(newUrl).toLowerCase();
}

/**
 * 签名
 * @param 入参
 */
export function sign(params) {
    if (typeof params == "string") {
        return paramsStrSort(params);
    } else if (typeof params == "object") {
        var arr = [];
        for (var i in params) {
            if (params[i] !== '' && params[i] != undefined && params[i] != null) {
                arr.push((i + "=" + params[i]));
            }
        }
        return paramsStrSort(arr);
    }
}

/**
 * 随机字符串
 * @length 长度
 */
export function randomString(length) {
    length = length || 32;
    var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678$#@%^&*",
        a = t.length,
        n = "";
    for (let i = 0; i < length; i++) n += t.charAt(Math.floor(Math.random() * a));
    return n
}
/**
 * 禁止双击或者双指放大
 */
export const disabledScale = () => {
    var lastTouchEnd = 0;
    document.addEventListener('touchstart', function(event) {
        if (event.touches.length > 1) {
            event.preventDefault();
        }
    });
    document.addEventListener('touchend', function(event) {
        var now = (new Date()).getTime();
        if (now - lastTouchEnd <= 300) {
            event.preventDefault();
        }
        lastTouchEnd = now;
    }, false);

    // 阻止双指放大
    document.addEventListener('gesturestart', function(event) {
        event.preventDefault();
    })
}



/**
 * 是否微信浏览器
 */
export function isWxBrowser() {
    let u = navigator.userAgent
    if (u.indexOf('MicroMessenger') != -1) {
        return true
    }
    return false
}

/**
 *  URL加密
 * @param {*} str 
 * @returns 
 */
export function encode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
            return String.fromCharCode('0x' + p1);
        }));
};

/**
 * URL解密
 * @param {*} str 
 * @returns 
 */
export function decode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}


/**
 * 判断是否是微信环境
 */
export function isWeiXin() {
    const ua = window.navigator.userAgent.toLowerCase()
    if (ua.indexOf('micromessenger') > -1) {
        return true // 是微信端
    } else {
        return false
    }
}

/**
 * 判断是否是手机端环境
 */
export function isMobile() {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
        return true // 手机端
    } else {
        return false // alert('PC端')
    }
}